module.exports = __webpack_public_path__ + "static/media/edit.21422882.svg";